import React from "react"
import { ReactComponent as Dashboard } from "../../assets/Icons/dashboard.svg?react"
import { ReactComponent as HomeIcon }  from "../../assets/Icons/home.svg?react"
import { ReactComponent as Logout } from "../../assets/Icons/logout.svg?react"
import { ReactComponent as Settings } from "../../assets/Icons/settings.svg?react"
import { ReactComponent as Permission } from "../../assets/Icons/permission.svg?react"
import { ReactComponent as People } from "../../assets/Icons/people.svg?react"
import { ReactComponent as Setting } from "../../assets/Icons/setting.svg"
import { ReactComponent as Privacy } from "../../assets/Icons/privacy.svg"
import { ReactComponent as Password } from "../../assets/Icons/password.svg"
import { ReactComponent as Analytics } from "../../assets/Icons/analytics.svg"
import { ReactComponent as Terms } from "../../assets/Icons/terms.svg"
import { ReactComponent as List } from "../../assets/Icons/list.svg"
import { ReactComponent as Case } from "../../assets/Icons/case.svg"
import { ReactComponent as Bed } from "../../assets/Icons/bed.svg"
import { ReactComponent as Bus } from "../../assets/Icons/bus.svg"
import { ReactComponent as Activity } from "../../assets/Icons/activity.svg"
import { ReactComponent as Dining } from "../../assets/Icons/dining.svg"
import { ReactComponent as JsonOpen } from "../../assets/Icons/json_open.svg"
import { ReactComponent as JsonClose } from "../../assets/Icons/json_close.svg"
import { ReactComponent as Tips } from "../../assets/Icons/tips.svg"
import { ReactComponent as BestTime } from "../../assets/Icons/best_time.svg"
import { ReactComponent as No } from "../../assets/Icons/no.svg"
import { ReactComponent as Package } from "../../assets/Icons/package.svg"
import { ReactComponent as Document } from "../../assets/Icons/document.svg"
import { ReactComponent as Trending } from "../../assets/Icons/trending.svg"
import { ReactComponent as Recommended } from "../../assets/Icons/recommend.svg"
import { ReactComponent as CMS } from "../../assets/Icons/cms.svg"
import { ReactComponent as CMS_HOME } from "../../assets/Icons/home_cms.svg"
import { ReactComponent as Category } from "../../assets/Icons/category.svg"
import { ReactComponent as Subscription } from "../../assets/Icons/subscription.svg"
import { ReactComponent as Planlist } from "../../assets/Icons/planlist.svg"
import { ReactComponent as PaymentLog } from "../../assets/Icons/paymentlog.svg"
import { ReactComponent as User } from "../../assets/Icons/user.svg"
import { ReactComponent as UsersList } from "../../assets/Icons/userslist.svg"
import { ReactComponent as QuestionHistory } from "../../assets/Icons/question_history.svg"
import { ReactComponent as Preference } from "../../assets/Icons/preference.svg"
import { ReactComponent as massNotification } from "../../assets/Icons/massNotification.svg"
import { ReactComponent as userLogs } from "../../assets/Icons/userLogs.svg"
import { ReactComponent as others } from "../../assets/Icons/others.svg"
import { ReactComponent as travelType } from "../../assets/Icons/travel_type.svg"
import { ReactComponent as form_question} from "../../assets/Icons/form_question.svg"
import { ReactComponent as form_list} from "../../assets/Icons/form_list.svg"
import { ReactComponent as user_metrics} from "../../assets/Icons/user_metrics.svg"
import { ReactComponent as master_tags} from "../../assets/Icons/master_tags.svg"
import { ReactComponent as email_campaign} from "../../assets/Icons/email_campaign.svg"



const styleIcon = {
  height: "20px",
  width: "20px",
  marginRight: "5px",
}

const iconTypes = {
  dashboard: Dashboard,
  settings: Settings,
  home: HomeIcon,
  logout: Logout,
  permission: Permission,
  people: People,
  setting: Setting,
  privacy:Privacy,
  analytics: Analytics,
  password: Password,
  terms: Terms,
  list: List,
  case: Case,
  bed: Bed,
  bus: Bus,
  dining: Dining,
  activity: Activity,
  json_open:  JsonOpen,
  json_close: JsonClose,
  tips: Tips,
  best_month_to_visit: BestTime,
  month_to_avoid: BestTime,
  ignored_user_preference: No,
  tournament_booking_assistance: Tips,
  package: Package,
  documents: Document,
  Recommended: Recommended,
  Trending: Trending,
  CMS_HOME: CMS_HOME,
  CMS: CMS,
  Category: Category,
  restaurants: Dining,
  stay: Bed,
  transport: Bus,
  subscription: Subscription,
  planlist: Planlist,
  paymentLog: PaymentLog,
  user: User,
  userlist: UsersList,
  question_history: QuestionHistory,
  preference: Preference,
  userLogs: userLogs,
  massNotification: massNotification,
  others: others,
  tour_guide: Activity,
  travel_type: travelType,
  form_question: form_question,
  form_list: form_list,
  user_metrics: user_metrics,
  master_tags: master_tags,
  email_campaign: email_campaign
}

const Icon = ({ name, style }) => {
  return iconTypes[name] ? React.createElement(iconTypes[name], { style: style || styleIcon }) : null
}

export default Icon
